import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { WalletKey } from 'api/Wallet/Types/Wallet'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

import './Wallets.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const walletsColumn: GridColumn[] = [
  {
    title: 'Wallet number',
    field: WalletKey.name,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsWallets.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
    filter: 'text',
    show: true,
    width: 180,
    className: 'wallet-table-columns__content',
  },
  {
    title: 'Client',
    field: WalletKey.client,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline', width: 'auto' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.client.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.client.name}
        </Link>
      </td>
    ),
    filter: 'text',
    show: true,
    width: 220,
    minResizableWidth: 220,
  },
  {
    title: 'Type',
    field: WalletKey.walletType,
    show: true,
    className: 'wallet-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'State',
    field: WalletKey.walletState,
    show: true,
    className: 'wallet-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Currency',
    field: WalletKey.currency,
    show: true,
    className: 'wallet-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Reserved',
    field: WalletKey.reserved,
    show: true,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__number'>{gridCellProps.dataItem.reserved.toFixed(2)}</td>
    ),
    className: 'wallet-table-columns__number',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Balance',
    field: WalletKey.balance,
    show: true,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__number'>{gridCellProps.dataItem.balance.toFixed(2)}</td>
    ),
    className: 'wallet-table-columns__number',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Entity',
    field: WalletKey.companyName,
    show: true,
    className: 'wallet-table-columns__content',
    filterable: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.company?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.company.id}>{props.dataItem.company.name}</CompanyTag>
        </td>
      )
    },
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
  {
    title: 'Date Created',
    field: WalletKey.createdDate,
    minResizableWidth: 120,
    width: 120,
    show: true,
    cell: (props: GridCellProps) => (
      <td className='transaction-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
    filter: 'text',
  },
]

export default walletsColumn
